import { TagContainer, TagInput } from '@calendly/tags';
import classNames from 'classnames';
import { useState, useCallback, useRef, useMemo, forwardRef } from 'react';
import { isEnterKey, isSpaceKey, isTabKey, isCommaKey, isBackspaceKey } from 'services/keycodes';
import { DELIMITER_CHARS, DELIMITER_CHARS_REGEXP, VALID_EMAIL_REGEXP } from './constants';
import { Tag } from './tag/tag';
const styledTagContainerCss = "s1cauzg2";
const StyledTagContainer = forwardRef((props, ref) => <TagContainer ref={ref} {...props} className={classNames(styledTagContainerCss, props.className)} />);
export const InviteeInput = ({
  inviteeList,
  invalidEmails,
  isFocused,
  focus,
  blur,
  error,
  onAdd,
  onUpdate,
  onRemove,
  dismissError,
  ...inputProps
}) => {
  const [inputValue, setInputValue] = useState('');
  const tagInputRef = useRef(null);
  const invalidEmailsSet = useMemo(() => new Set(invalidEmails), [invalidEmails]);
  const tags = useMemo(() => {
    const isValidEmail = email => !invalidEmailsSet.has(email) && VALID_EMAIL_REGEXP.test(email);
    const isEmailDuplicated = email => inviteeList.filter(invitee => invitee.email === email).length > 1;
    return inviteeList.map(({
      id,
      email
    }) => ({
      id,
      email,
      isValid: !isEmailDuplicated(email) && isValidEmail(email),
      onChange: newEmail => onUpdate(id, newEmail)
    }));
  }, [inviteeList, onUpdate, invalidEmailsSet]);
  const handleFocus = useCallback(() => {
    focus();
  }, [focus]);
  const handleAdd = useCallback(() => {
    if (inputValue.length) {
      onAdd(inputValue);
    }
    setInputValue('');
  }, [onAdd, inputValue]);
  const handleAddOnBlur = useCallback(() => {
    handleAdd();
    blur();
  }, [handleAdd, blur]);
  const handleBeforeInput = useCallback(event => {
    if (DELIMITER_CHARS.includes(event.data)) {
      handleAdd();
      event.preventDefault();
    }
  }, [handleAdd]);
  const handleKeyDown = useCallback(event => {
    dismissError();
    if (isEnterKey(event) || isCommaKey(event) || isSpaceKey(event)) {
      handleAdd();
      event.preventDefault();
    } else if (isBackspaceKey(event)) {
      if (!inputValue.length) {
        const lastTagId = tags[tags.length - 1].id;
        onRemove(lastTagId);
      }
    } else if (isTabKey(event)) {
      if (inputValue.length) {
        handleAdd();
        event.preventDefault();
      }
    }
  }, [dismissError, handleAdd, inputValue.length, tags, onRemove]);
  const handlePaste = useCallback(event => {
    const pasteText = event.clipboardData.getData('Text');
    pasteText.split(DELIMITER_CHARS_REGEXP).filter(Boolean).map(email => email.trim()).forEach(onAdd);
    event.preventDefault();
  }, [onAdd]);
  const handleMouseDown = useCallback(() => {
    focus();
  }, [focus]);
  return <StyledTagContainer isError={error} ref={tagInputRef} onKeyDown={handleKeyDown} onInputChange={setInputValue} onBeforeInput={handleBeforeInput} onPaste={handlePaste} onInputFocus={handleFocus} onInputBlur={handleAddOnBlur} isFocused={isFocused} onMouseDown={handleMouseDown} inputValue={inputValue} inputAttributes={{
    ...inputProps,
    type: 'email',
    id: 'delete_invitees',
    'aria-controls': 'delete_invitees',
    'aria-label': 'delete_invitees',
    'aria-expanded': 'true'
  }} data-testid="delete_invitees">
      {tags.map(({
      id,
      email,
      onChange,
      isValid
    }) => <Tag key={id} id={id} name={email} isValid={isValid} onChange={onChange} onDelete={onRemove} tagInputRef={tagInputRef} />)}
      <TagInput />
    </StyledTagContainer>;
};

require("./invitee_input.wyw-in-js.css!=!../../../../../node_modules/@wyw-in-js/webpack-loader/lib/outputCssLoader.js?cacheProvider=!./invitee_input.js");